// extracted by mini-css-extract-plugin
export default {"containprod":"rB","containprod2":"sB","title":"tB","servings":"uB","recommendation":"vB","image":"wB","flavorswrap":"xB","flavorsgroupwrap":"yB","moredetailsWrap":"zB","infoWrap":"AB","price":"BB","regularPrice":"CB","netPrice":"EB","addtocartcontainer":"FB","error":"GB"};
    if(module.hot) {
      // 1711717533359
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  